import 'leaflet/dist/leaflet.css';

import { AdminContainer } from '@/components/containers';
import { UsersTable } from '@/components/tables/users-table.component';
import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';

function UserList() {
  return (
    <IfPermitted permissions={[UserPermissions.USER_LIST]}>
      <AdminContainer className={cn('flex flex-col')} title="Users">
        <UsersTable />
      </AdminContainer>
    </IfPermitted>
  );
}

export default UserList;
